// @flow

import React from "react";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";

const SECONDS_PER_MINUTE = 60;

export type Props = $Exact<{
  value: number,
  required: boolean,
  options: Object,
  onChange: (value: number) => {},
}>;

export class SecondsAsMinutesInput extends React.Component<Props> {
  toHours = (seconds: number) =>
    isNaN(seconds) ? 0 : Math.round((seconds / SECONDS_PER_MINUTE) * 10) / 10;

  toSeconds = (hours: number) => hours * SECONDS_PER_MINUTE;

  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    this.props.onChange(
      !isNaN(event.currentTarget.value)
        ? this.toSeconds(+event.currentTarget.value)
        : this.props.value,
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className="form-control__with-label">
          <input
            type="number"
            className="form-control"
            value={this.toHours(this.props.value) || null}
            required={this.props.required}
            onChange={this.handleChange}
          />
          <label>minutes</label>
        </div>
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </React.Fragment>
    );
  }
}

export default SecondsAsMinutesInput;
